export interface AssortimentCategory {
  slug: string;
  label: string;
  subcategories: string[];
}

export const ASSORTIMENT_CATEGORIES: AssortimentCategory[] = [
  { slug: "cameras", label: "Camera's", subcategories: ["ip-cameras", "ptz-camera"] },
  { slug: "recorders", label: "Recorders", subcategories: ["netwerk-recorders"] },
  { slug: "beugels", label: "Beugels", subcategories: ["bevestigingsbeugels"] },
  { slug: "opslag", label: "Opslag", subcategories: ["opslagmedia"] },
  { slug: "kabels", label: "Kabels", subcategories: ["data-kabel"] },
  { slug: "intercom", label: "Intercom", subcategories: ["intercomsystemen"] },
];

// Subcategorieën die op dit moment daadwerkelijk producten bevatten.
// Pas deze set aan wanneer er producten in nieuwe subcategorieën worden toegevoegd.
const POPULATED_SUBCATEGORIES = new Set([
  "ip-cameras",
  "netwerk-recorders",
  "intercomsystemen",
]);

export const POPULATED_ASSORTIMENT_CATEGORIES = ASSORTIMENT_CATEGORIES.filter(
  (category) => category.subcategories.some((sub) => POPULATED_SUBCATEGORIES.has(sub))
);
